import { RecoilState, useSetRecoilState } from "recoil"
import { useAsyncSelector } from "./useAsyncSelector"

export const useAsyncState = <T>(recoilState: RecoilState<T>) => {
  const { value, isLoading, error } = useAsyncSelector(recoilState)
  const setter = useSetRecoilState(recoilState)

  return [value, setter, isLoading, error] as const
}
